import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import AdsPlacementStatuses from 'src/app/constants/ads-placement-statuses';
import { AdsPlacementService } from 'src/app/classes/ads-placement.service';
import { AdsPlacement } from 'src/app/classes/ads-placement';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  adsPlacements: AdsPlacement[] = [];

  adsPlacementStatuses = AdsPlacementStatuses;

  constructor(
    private adsPlacementService: AdsPlacementService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.adsPlacementService.search(params).subscribe(adsPlacements => {
        this.adsPlacements = adsPlacements;
      });
    });
  }

  delete(id: number) {
    if(confirm($localize`Are you sure?`)) {
      this.adsPlacementService.delete(id).subscribe(() => {
        this.adsPlacementService.search(this.route.snapshot.queryParams).subscribe(adsPlacements => {
          this.adsPlacements = adsPlacements;
        });
      });
    }
  }
}
